import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

// components
import { MainHolder, StyledText } from "../../../components/common";

//svgs
import { NewBackButton } from "../../../components/svgs";
import PrizeCard from "../../../components/loyalty/prizeCard";
import { useTrivia } from "../../../hooks";
import useTriviaPickup from "./hooks/useTriviaPickup";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const PickVoucher = () => {
  const history = useHistory();
  const {
    activeTrivia,
    setActiveVoucher,
    rewardAvailability,
    checkRewardAvailability,
  } = useTrivia();
  const { availableRewardTypes = [], rewardStock } = activeTrivia || {};
  const {
    setRegion,
    setOfficeLocation,
    handleSubmit,
    voucherData,
  } = useTriviaPickup();
  const [showVoucherData, setShowVoucherData] = useState({});

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };
  const { rewardScheme, whiteListedLocations } = activeTrivia || {};

  useEffect(() => {
    if (availableRewardTypes.includes("silverbird")) {
      const region = "Greater Accra";
      const officeLocation = "Accra Mall";
      setActiveVoucher("silverbird")
      setRegion(region)
      setOfficeLocation(officeLocation)
      handleSubmit({
        rewardType: "silverbird",
        region,
        officeLocation,
      })
      history.push(`/trivia/order_details`);
    } else if (availableRewardTypes.length < 1 && rewardScheme !== "online") {
      history.push(`/trivia/redeem-onground`)
    } else if (availableRewardTypes.length < 1 && rewardScheme == "online")  {
      history.push(`/trivia/trivia-category`)
    }
  }, [availableRewardTypes]);

  const handleVoucherClick = (voucher) => {
    setActiveVoucher(voucher);
    if (rewardScheme === "online") {
      history.push(`/trivia/select_pickup_location`);
    } else if (availableRewardTypes.length) {
      handleSubmit({
        rewardType: voucher,
        region: "Greater Accra",
        officeLocation: whiteListedLocations[0],
      })
      history.push(`/trivia/order_details`);
    }
  }

  useEffect(() => {
    if (rewardStock) {
      checkRewardAvailability(activeTrivia?._id)
    }
  }, [rewardStock])

  useEffect(() => {
    if (rewardAvailability?.data) {
      if (rewardStock) {
        const showVoucherData = availableRewardTypes.reduce((prev, cur) => {
          return { ...prev, [cur]: rewardAvailability?.data[cur] > 0 ? true : false }
        }, {});
        setShowVoucherData(showVoucherData);
      }
    } else {
      const showVoucherData = availableRewardTypes.reduce((prev, cur) => {
        return { ...prev, [cur]: true }
      }, {});
      setShowVoucherData(showVoucherData);
    }
  }, [rewardAvailability?.data])


  return (
    <MainHolder
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: "0 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <BackButtonContainer
          onClick={() => {
            goToHome();
          }}
        >
          <NewBackButton />
        </BackButtonContainer>
        <StyledText style={{ fontSize: 22 }}>Select Preferred Prize</StyledText>
        <StyledText>{""}</StyledText>
      </div>

      {rewardAvailability?.isLoading && (
        <div style={{ textAlign: "center" }}>
          <img
            alt="Loader"
            style={{ width: "70px" }}
            src={`${SERVER_URL}/assets/images/loading.gif`}
          />
        </div>
      )}

      <div style={{ display: rewardAvailability?.isLoading ? 'none' : 'block' }}>
        <div style={{
          display: "flex",
          flexWrap: 'wrap',
          justifyContent: "center",
          alignTtems: "center"
        }}>
          {
            Object.keys(voucherData).map((item) => {
              if (availableRewardTypes.includes(item) && showVoucherData[item]) {
                if (['airtime', 'silverbird'].includes(item)) return
                return (
                  <PrizeCard
                    onPress={() => {
                      handleVoucherClick(item);
                    }}
                    img={voucherData[item].imageUrl}
                    prize={voucherData[item].value ? `GHS ${voucherData[item].value}` : ''}
                    description={voucherData[item].name}
                  />
                )
              }
              return <></>
            })
          }

          {
            availableRewardTypes.includes("airtime") && (
              <PrizeCard
                onPress={() => {
                  setActiveVoucher("airtime");
                  history.push(`/trivia/confirm?voucher=airtime`);
                }}
                img={`${SERVER_URL}/assets/images/airtime.jpg`}
                prize={"GHS 10.00"}
                description={"Airtime"}
              />
            )
          }

          {/* <PrizeCard
          onPress={() => {
            history.push(`/trivia/confirm?voucher=data`);
          }}
          img={`${SERVER_URL}/assets/images/airtime.jpg`}
          prize={"8 GB"}
          description={"Data"}
        /> */}
        </div>
      </div>
    </MainHolder >
  );
};

export default PickVoucher;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
